import VueGtm from 'vue-gtm';
import Vue from 'vue';
import router from '../router';

const isProd = process.env.NODE_ENV === 'production';

Vue.use(VueGtm, {
    id: 'GTM-MBLH954',
    enabled: isProd, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
    debug: true, // Whether or not display console logs debugs (optional)
    loadScript: false,
    vueRouter: router
});
